import { render, staticRenderFns } from "./asset-group.vue?vue&type=template&id=6a400e06&scoped=true"
import script from "./asset-group.vue?vue&type=script&lang=js"
export * from "./asset-group.vue?vue&type=script&lang=js"
import style0 from "./asset-group.vue?vue&type=style&index=0&id=6a400e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a400e06",
  null
  
)

export default component.exports